import {
  GetIconColorFunction,
  HierarchyContext,
  IHierarchyContextValue,
  nodeType,
} from "@fidelix/fx-miranda";
import { useDeviceStateContext } from "../device/device-status-context";
import { getDeviceStatusColor } from "../device/device.utils";
import { hoveredNode } from "./tree-render.utils";
import { fetchNodes, searchNodes } from "./tree.queries";

export function TreeProvider({ children }) {
  const { getDeviceState, getDevice } = useDeviceStateContext();

  const getIconColor: GetIconColorFunction = (node) =>
    node.type === nodeType.device || node.type === nodeType.deviceGraphic
      ? getDeviceStatusColor(
          getDeviceState(node.getId()),
          getDevice(node.getId()).lastOnlineAt,
        )
      : undefined;

  const value: IHierarchyContextValue = {
    onHover: hoveredNode,
    getIconColor,
    fetchNodes,
    searchNodes,
  };

  return (
    <HierarchyContext.Provider value={value}>
      {children}
    </HierarchyContext.Provider>
  );
}
